import {
  isBankAccountMetadataValid,
  isCreditCardMetadataValid,
} from './helpers.js'
import { FEE_MODE } from 'Data/constants.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  return function onChange(value, change) {
    change(next => {
      // recompute this flag to be available for children components (disables the submit action)
      next.is_fee_applicable =
        isFeeAcknowledgementRequired(value) &&
        // platform fee or surcharge not yet supported for insurance payments
        value.account_type !== 'InsurancePaymentAccount' &&
        !!value.provider_location_account_id
    })

    if (value.add_new && value.provider === 'bluefin') {
      let nextValid =
        value.method === 'card'
          ? isCreditCardMetadataValid(value.credit_card)
          : isBankAccountMetadataValid(value.bank_account)

      if (nextValid !== value.valid) {
        change(next => {
          next.valid = nextValid
        })
      }
    }
  }
}

function isFeeAcknowledgementRequired(value) {
  switch (value.fee_mode) {
    case FEE_MODE.PLATFORM_FEE:
      return (
        (value.method === 'ach' || value.method === 'card') &&
        value.state === 'ready'
      )
    case FEE_MODE.SURCHARGE:
      // surcharge only supported on card payments
      return value.method === 'card' && value.state === 'ready'
    case FEE_MODE.STANDARD:
    default:
      return false
  }
}
